import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  AssignCustomerCase,
  AssignCustomerCaseInput,
  CustomerCase,
  EllipticTransaction,
  ServerResponse
} from '@shared/types';
import { map, Observable } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({ providedIn: 'root' })
export class CasesSharedService {
  private httpClient = inject(HttpClient);
  private utilsService = inject(UtilsService);

  /**
   * Assigns a case to a user.
   * used for customer cases, elliptic cases and travel rule cases
   * @param assignments The case assignments to be processed.
   * @returns An Observable that emits the server response.
   */
  public assignCase(
    assignments: AssignCustomerCaseInput | AssignCustomerCaseInput[]
  ): Observable<ServerResponse<AssignCustomerCase[]>> {
    const apiUrl = this.utilsService.buildApiUrl(`transaction-generic/assign/`);
    const payload = Array.isArray(assignments) ? assignments : [assignments];
    return this.httpClient
      .post<ServerResponse<AssignCustomerCase[]>>(apiUrl, payload)
      .pipe(map((response) => response));
  }

  /**
   * Updates the due date for a case.
   * used for customer cases and elliptic cases
   * @param code The code of the case to update.
   * @param due_date The new due date for the case.
   * @returns An Observable that emits the server response.
   */
  public updateCaseDueDate(
    code: string,
    due_date: string
  ): Observable<ServerResponse<CustomerCase | EllipticTransaction>> {
    const apiUrl = this.utilsService.buildApiUrl(`customer-case/case/`);
    return this.httpClient
      .post<
        ServerResponse<CustomerCase | EllipticTransaction>
      >(apiUrl, { code, due_date })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
